// extracted by mini-css-extract-plugin
module.exports = {"content":"Events_content__3Y2q8","icon":"Events_icon__2iCGj","eventDetails":"Events_eventDetails__2mTi0","labels":"Events_labels__19dKL","hideIcon":"Events_hideIcon__2spLx"};